import { useState, useEffect } from "react";
import styles from "./Footer.module.css";

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.brand}>
          <div className={styles.logo}>
            <img src="https://res.cloudinary.com/dljf2mhkb/image/upload/v1769960213/course_images/f964f226-2818-4360-bb15-a305e79bcf08-RT2_g9dboy.png.png" alt="Hackerblog Logo" />
            <h1>Hackerblog</h1>
          </div>
          <p className={styles.desc}>
            HackerBlog is the premier online destination for those interested in technology, coding, security, and more. We provide the latest news, tutorials, reviews, and guides to keep you updated with tech trends.
          </p><br />
          <a href="https://www.sitelock.com/verify.php?site=hackerblog.co.in">
            <img className={styles.playStoreBadge} alt="SiteLock" title="SiteLock" src="https://shield.sitelock.com/shield/hackerblog.co.in" />
          </a>

          <div className={styles.downloadApp}>
            <p>Download Our App</p>
            <a href="https://play.google.com/store/apps/details?id=xyz.hackerblog&hl=en_US&gl=US">
              <img
                src="https://res.cloudinary.com/dljf2mhkb/image/upload/v1769676795/en_badge_web_generic_ko7cnr.png"
                alt="Download Our App on Google Play"
                className={styles.playStoreBadge}
              /></a>

          </div>
        </div>

        <div className={styles.contact}>
          <h3>Contact</h3>
          <div className={styles.contactItem}>
            <p className={styles.value}>+91 7080539054</p>
            <p className={styles.label}>Support Number</p>
          </div>
          <div className={styles.contactItem}>
            <p className={styles.value}>hackerblogdomain@gmail.com</p>
            <p className={styles.label}>Support Email</p>
          </div>
          <div className={styles.contactItem}>
            <p className={styles.value}>425, Turnanganj, Kalpi - 285204</p>
            <p className={styles.label}>Address</p>
          </div>
        </div>

        <div className={styles.pages}>
          <h3>Pages</h3>
          <ul>
            <li><a href="https://lms.hackerblog.co.in/careers">Careers</a></li>
            <li><a href="https://hackerblog.co.in/Term.html">Terms and Conditions</a></li>
            <li><a href="https://docs.google.com/document/d/1ZH-vt20myNQ-57rGAn79GltDt8yVqNCUFRyDy5L9W9Q/edit?tab=t.0#heading=h.6g1zbn61mcqw">Privacy Policy</a></li>
          </ul>
        </div>

        <div className={styles.social}>
          <h3>Connect With Us</h3>
          <div className={styles.socialIcons}>
            <a href="https://www.facebook.com/HackerblogOfficial" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M22.675 0H1.325C.593 0 0 .593 0 1.325v21.351C0 23.407.593 24 1.325 24H12.82v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116c.73 0 1.323-.593 1.323-1.325V1.325C24 .593 23.407 0 22.675 0z" /></svg>
            </a>
            <a href="https://instagram.com/hackerblog.co.in" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" /></svg>
            </a>
            <a href="https://cehvarunsingh.medium.com/" target="_blank" rel="noopener noreferrer" aria-label="Medium">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M13.54 12a6.8 6.8 0 01-6.77 6.82A6.8 6.8 0 010 12a6.8 6.8 0 016.77-6.82A6.8 6.8 0 0113.54 12zM20.96 12c0 3.54-1.51 6.42-3.38 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.38 2.88 3.38 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z" /></svg>
            </a>
            <a href="https://t.me/hackerblogcompany" target="_blank" rel="noopener noreferrer" aria-label="Telegram">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.295-.6.295-.002 0-.003 0-.005 0l.213-3.054 5.56-5.022c.24-.213-.054-.334-.373-.121l-6.869 4.326-2.96-.924c-.64-.203-.658-.64.135-.954l11.566-4.458c.538-.196 1.006.128.832.94z" /></svg>
            </a>
            <a href="https://in.linkedin.com/company/hackerblogcompany" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" /></svg>
            </a>
            <a href="https://www.youtube.com/@hackerblogofficial7931" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.5 12 3.5 12 3.5s-7.505 0-9.377.55a3.016 3.016 0 00-2.122 2.136C0 8.07 0 12 0 12s0 3.93.501 5.814a3.016 3.016 0 002.122 2.136c1.871.55 9.377.55 9.377.55s7.505 0 9.377-.55a3.016 3.016 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" /></svg>
            </a>
          </div>
        </div>
      </div>
      <div className={styles.copyright}>
        <p>&copy; 2022-26 Hackerblog. All rights reserved.
          <br />Version 19.0
        </p>
      </div>

      {isVisible && (
        <button onClick={scrollToTop} className={styles.backToTop} aria-label="Back to top">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
            <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
          </svg>
        </button>
      )}

    </footer>
  );
};

export default Footer;
